import React from "react";
import { LabeledText } from "components/LabeledText/LabeledText";
import { TwoColumnsLayout } from "components/TwoColumnsLayout/TwoColumnsLayout";
import { Application } from "interfaces/data";
import { useTranslation } from "react-i18next";
import { findCountry } from "helpers/findCountry";

interface CompanyAddressProps {
  application: Application;
}

export function CompanyAddress({ application }: CompanyAddressProps) {
  const { t } = useTranslation();
  return (
    <TwoColumnsLayout>
      <LabeledText label={t("application:Street")} value={application.companyAddress?.street} />
      <LabeledText label={t("application:Apt number")} value={application.companyAddress?.number} />
      <LabeledText label={t("application:Code")} value={application.companyAddress?.code} />
      <LabeledText label={t("application:City")} value={application.companyAddress?.city} />
      <LabeledText label={t("application:Country")} value={findCountry(application.companyAddress?.country)} />
    </TwoColumnsLayout>
  );
}
